import $ from 'jquery';

export default class PhoneConsultation {
  static init() {
    $('#phone-consultation-form').on('submit', (e) => {
      e.preventDefault();
      const $form = $(e.currentTarget);

      let data = {
        action: 'faq_phone_consultation',
        question: $form.find('#faq_question').val(),
        name: $form.find('#question-first-name').val(),
        phone: $form.find('#question-phone').val(),
        email: $form.find("input[name='email']").val()
      };

      console.log(data);
		  
      $.post(window.ajaxurl, data, function(response) {
        if(response['status'] === 'success') {
          $.fancybox.open({
            src: '#faq-consultation-success',
            closeExisting: true,
            smallBtn: false,
            toolbar: false,
            touch: false,
          });
        } else {
          alert(response);
        }
      });
    });
  }
}
